/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React from "react";
import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import "../components/style.css";
import { Link, useLocation } from "react-router-dom";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import QRCode from "qrcode.react";
import ModalQRCodeMember from "../components/ModalQRCodeMember";
import ModalReFreshUpdate from "../components/ModalReFreshUpdate";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import {
  scrollToElement,
  handleResizeDisplay,
  checkGroupsUser,
  getlocalStorage,
  showLoading,
  hideLoading,
} from "../function/functionALL";
import ModalPagination from "../components/ModalPagination";
import LoadingTable from "../components/LoadingTable";
import CheckNoContent from "../components/CheckNoContent";
import { FaArrowAltCircleLeft, FaUndoAlt } from "react-icons/fa";
import Layout from "../components/Layout";

const PageManageUser = () => {
  const navigate = useNavigate();
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const [data, setdata] = useState([]);
  const [paginationNext, setpaginationNext] = useState([]);
  const [AmoutData, setAmoutData] = useState();

  const [stateSwitch, setSwitch] = useState(false);
  const [chkUser, setchkUser] = useState(false);
  const [isStacked, setIsStacked] = useState(false);
  const location = useLocation();
  const { props_search, props_pageNumber, props_AmountPage } =
    location?.state || {};
  const [search, setSearch] = useState("" || props_search);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [pageNumber, setPageNumber] = useState(props_pageNumber || 1);
  const topRef = useRef(null);
  const [loadingTable, setloadingTable] = useState(true); ////ทำงาน

  const fetchData = async (url, Token, InitialData) => {
    try {
      const response = await Axios.get(url, {
        headers: {
          Authorization: "Token " + Token,
        },
      });
      if (InitialData === true) {
        response.data.results.sort((a, b) => a.rank_id - b.rank_id);
        setloadingTable(false);
      } else {
        setloadingTable(true);
      }
      setloadingTable(false);
      return response.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }
      console.error(err);
      Swal.fire({
        icon: "error",
      });
    }
  };

  const loadData = async () => {
    let url;
    let InitialData;
    if (pageNumber > 1) {
      const offset = 25 * (pageNumber - 1);
      url = `${process.env.REACT_APP_API_USERS}?limit=25&offset=${offset}`;
      InitialData = false;
    } else {
      url = process.env.REACT_APP_API_USERS;
      InitialData = true;
    }
    try {
      const result = await fetchData(url, Token, InitialData, pageNumber === 1);
      setdata(result.results);
      if (pageNumber === 1) {
        setpaginationNext(result);
        setAmoutData(result.count);
        setSwitch(true);
        setchkUser(true);
        setloadingTable(false);
      }
    } catch (err) {
      if (err.message === "Unauthorized") {
        navigate("/notfound404");
      }
    }
  };

  useEffect(() => {
    initialfetch(search, props_search);
  }, [stateSwitch, chkUser, pageNumber, props_search]);

  const initialfetch = async (search, props_search) => {
    const txtSearch = (await search) || props_search;
    if (!txtSearch) {
      handleResizeDisplay(setIsStacked);
      loadData();
    } else if (txtSearch?.length > 1) {
      fetchSearchResults(search, Token);
      handleResizeDisplay(setIsStacked);
    }
  };

  const handleChangeSearch = async (e) => {
    const txt = await e.target.value;
    if (txt === "") {
      handleResizeDisplay(setIsStacked);
      loadData();
      setSearch("");
    } else {
      setSearch(e.target.value);
    }
  };

  const fetchSearchResults = async (search, Token) => {
    setLoadingSearch(true);
    setloadingTable(true);

    try {
      const response = await Axios.get(
        process.env.REACT_APP_API_USERS + `?search=${search}`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );

      if (!response.data.results || response.data.results.length === 0) {
        setdata([]);
        setLoadingSearch(false);
        setloadingTable(false);
      } else {
        setdata(response.data.results);
        setLoadingSearch(false);
        setloadingTable(false);
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }
      console.error(err);
      Swal.fire({
        icon: "error",
      });
    }
  };

  const searchValue = async (e) => {
    e.preventDefault();

    if (search?.length < 3) {
      Swal.fire({
        icon: "warning",
        title: "กรุณาค้นหา 3 ตัวอักษรขึ้นไป",
      });
      return;
    } else {
      await initialfetch(search, props_search);
    }
  };

  const UpdateData_id = (id) => {
    Axios.post(
      process.env.REACT_APP_API_UPDATE_IDUSER,
      {
        person_id: id,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "Update สำเร็จ!",
        });
        initialfetch(search, props_search);
        setSwitch(true);
        setchkUser(true);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        } else {
          console.log("Error: ", err.response.data.detail);
          Swal.fire({
            icon: "error",
            title: "Update ไม่สำเร็จ!",
          });
        }

        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };
  const AmountPage = Math.ceil(AmoutData / 25) || props_AmountPage;
  const handlePageChange = (pageNumber) => {
    // setloadingTable(true)

    setloadingTable(true);
    setPageNumber(pageNumber);
    //เลื่อนขึ้นไปดานบน
    scrollToElement(topRef);

    if (pageNumber === 1) {
      Axios.get(process.env.REACT_APP_API_USERS, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          res.data.results.sort((a, b) => a.rank_id - b.rank_id);
          setdata(res.data.results);
          setpaginationNext(res.data);
          setAmoutData(res.data.count);
          setloadingTable(false);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else {
      setloadingTable(true);

      let offset = 25 * (pageNumber - 1);
      let paginationNext =
        process.env.REACT_APP_API_USERS + `?limit=25&offset=${offset}`;
      Axios.get(paginationNext, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          setdata(res.data.results);
          setloadingTable(false);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    }
  };

  const toggleSwitch = (event, id) => {
    const AuthenAccess = event.target.id;
    const isChecked = event.target.checked;
    setSwitch(false);

    if (isChecked) {
      Axios.post(
        process.env.REACT_APP_API_USERS + `${id}/add_group/`,
        {
          group_name: AuthenAccess,
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )

        .then((res) => {
          setSwitch(true);
          setchkUser(true);
          // console.log("Switch is ON");
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.log("Error: ", err);
          Swal.fire({
            icon: "error",
            title: "Update ไม่สำเร็จ!",
          });
        });
    } else if (!isChecked) {
      Axios.post(
        process.env.REACT_APP_API_USERS + `${id}/remove_group/`,
        {
          group_name: AuthenAccess,
        },
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      )

        .then((res) => {
          setSwitch(true);
          setchkUser(true);
          // console.log("Switch is OFF");
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.log("Error: ", err);
          Swal.fire({
            icon: "error",
            title: "Update ไม่สำเร็จ!",
          });
        });
    } else {
      console.log("error");
      Swal.fire({
        icon: "error",
        title: "Update ไม่สำเร็จ!",
      });
    }
  };

  const YourInputComponent = ({ groups, id }) => {
    const checkRTAFPersonAdmin = () => {
      for (let i = 0; i < groups.length; i++) {
        if (groups[i].name === "RTAFPersonAdmin") {
          return true;
        }
      }
      return false;
    };

    const checkUnitAdmin = () => {
      for (let i = 0; i < groups.length; i++) {
        if (groups[i].name === "UnitAdmin") {
          return true;
        }
      }

      return false;
    };
    const checkFunctionaryTester = () => {
      for (let i = 0; i < groups.length; i++) {
        if (groups[i].name === "FunctionaryTester") {
          return true;
        }
      }
      return false;
    };

    const isRTAFPersonAdmin = checkRTAFPersonAdmin();
    const isUnitAdmin = checkUnitAdmin();
    const isFunctionaryTester = checkFunctionaryTester();

    return (
      <>
        <td
          data-label="สิทธิ์ผู้ใช้ทั่วไป"
          className="text-center "
          style={{ fontSize: "14px", verticalAlign: "middle" }}
        >
          <div className="form-check form-switch pt-1 ">
            <input
              className="form-check-input m-0 p-0  "
              type="checkbox"
              role="switch"
              id={`User`}
              style={{ fontSize: "18px" }}
              disabled
              defaultChecked={groups.length > 0 ? false : true}
              onChange={(event) => {
                toggleSwitch(event, id);
              }}
            ></input>
          </div>
        </td>
        {DataToken_.groups.includes("RTAFPersonAdmin") === true ? (
          <td
            data-label="สิทธิ์เจ้าหน้าที่กำลังพล ทอ."
            className="text-center"
            style={{ fontSize: "14px", verticalAlign: "middle" }}
          >
            <div className="form-check form-switch pt-1 ">
              <input
                className="form-check-input m-0 p-0"
                type="checkbox"
                role="switch"
                id="RTAFPersonAdmin"
                style={{ fontSize: "18px" }}
                defaultChecked={isRTAFPersonAdmin}
                onChange={(event) => {
                  toggleSwitch(event, id);
                }}
              ></input>
            </div>
          </td>
        ) : (
          ""
        )}

        <td
          data-label="สิทธิ์เจ้าหน้าที่ทดสอบ"
          className="text-center"
          style={{ fontSize: "14px", verticalAlign: "middle" }}
        >
          <div className="form-check form-switch pt-1">
            <input
              className="form-check-input m-0 p-0"
              type="checkbox"
              role="switch"
              id="FunctionaryTester"
              style={{ fontSize: "18px" }}
              defaultChecked={isFunctionaryTester}
              onChange={(event) => {
                toggleSwitch(event, id);
              }}
            ></input>
          </div>
        </td>

        <td
          data-label="สิทธิ์เจ้าหน้าที่กำลังพลหน่วย"
          className="text-center"
          style={{ fontSize: "14px", verticalAlign: "middle" }}
        >
          <div className="form-check form-switch pt-1">
            <input
              className="form-check-input m-0 p-0"
              type="checkbox"
              role="switch"
              id="UnitAdmin"
              style={{ fontSize: "18px" }}
              defaultChecked={isUnitAdmin}
              onChange={(event) => {
                toggleSwitch(event, id);
              }}
            ></input>
          </div>
        </td>
      </>
    );
  };

  //--------------------ModalReFreshUpdate-------------//

  const [User_id, setUser_id] = useState("");
  const [chkEmpty, setChkEmpty] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingData_id, setloadingData_id] = useState(false);
  const triggerButtonRef = useRef(null);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const handleSave = (resultData_id) => {
    showLoading();

    Axios.post(
      process.env.REACT_APP_API_UPDATE_IDUSER,
      {
        person_id: User_id,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        hideLoading();
        Swal.fire({
          icon: "success",
          title: "Update สำเร็จ!",
        });

        setUser_id("");
        if (triggerButtonRef.current) {
          triggerButtonRef.current.focus();
        }
      })
      .catch((err) => {
        hideLoading();
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        hideLoading();
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  return (
    <>
      <Layout>
        <div ref={topRef}>
          <Form>
            <style>
              {`
        .mr10 {margin-right: 10px;}
      `}
            </style>
            <div className="App login-box">
              <section
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  backgroundSize: "cover",
                  minHeight: "1180px",
                }}
              >
                <div className="mb-0 rounded" style={{ padding: "68px 0 0 0" }}>
                  <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3">
                    <div className="p-3">
                      <div
                        className="card col-sm-12 col-xs-12"
                        style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}
                      >
                        <div className="card-body rounded">
                          <div className="row d-flex p-2 mt-2">
                            <div className="text-start col-1 col-sm-2 p-0 h-100 ">
                              <Link
                                to="/PageHome"
                                style={{ display: "inline-block" }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary m-0 d-none d-md-block px-4"
                                  style={{
                                    backgroundColor: "rgb(2, 117, 216,0.80)",
                                    border: "none",
                                  }}
                                >
                                  ย้อนกลับ
                                </button>
                                <FaArrowAltCircleLeft
                                  style={{ fontSize: "22px", color: "#3399FF" }}
                                  className="mt-2 d-md-none"
                                />
                              </Link>
                            </div>
                            <div
                              className=" col-10 col-sm-8 card-title text-center fs-5 fs-3 py-1"
                              style={{ color: "#000000" }}
                            >
                              <div
                                className="fw-bold"
                                style={{ fontSize: "21px" }}
                              >
                                จัดการกำลังพลภายในหน่วย
                              </div>
                            </div>
                            <div
                              className=" col-12 col-sm-12 text-center fw-bold mb-3"
                              style={{ fontSize: "16px" }}
                            ></div>
                            <hr></hr>
                          </div>
                          <div className="m-3">
                            <div
                              className="row d-flex justify-content-between fw-bold"
                              style={{ fontSize: "16px", color: "#616161" }}
                            >
                              <div className="row col-12 col-md-9 ms-1 ">
                                <div
                                  className="col-12 col-sm-6 col-md-6 col-lg-5 d-flex align-items-sm-center justify-content-center  ms-sm-0 "
                                  style={{ fontSize: "20px" }}
                                >
                                  สังกัด : {DataToken_.work_unit}
                                </div>
                                <div
                                  className="col-12 col-sm-6 col-md-6 col-lg-6 col-xxl-3 mt-3 mt-sm-0  d-flex justify-content-center"
                                  onClick={openModal}
                                  ref={triggerButtonRef}
                                >
                                  <button
                                    type="button"
                                    className="col-8 col-sm-10 btn btn-primary px-3 mx-sm-0 "
                                    style={{
                                      backgroundColor: "rgb(2, 117, 216,0.80)",
                                      border: "none",
                                    }}
                                  >
                                    <div
                                      className="mt-1"
                                      style={{ fontSize: "14px" }}
                                    >
                                      <FaUndoAlt /> ดึงข้อมูลจาก HRIS{" "}
                                    </div>
                                  </button>
                                </div>
                              </div>
                              <div className="col-12 col-md-3 has-validation mt-2 mt-xl-0">
                                <div className="input-group">
                                  <input
                                    className="form-control"
                                    placeholder="ค้นหา / Search"
                                    onChange={handleChangeSearch}
                                    defaultValue={search || props_search}
                                    // value={search|| props_search}
                                  />

                                  {loadingSearch ? (
                                    <button
                                      className="input-group-text"
                                      style={{
                                        backgroundColor: "#FFB545",
                                        border: "none",
                                      }}
                                    >
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                      กรุณารอสักครู่...
                                    </button>
                                  ) : (
                                    <button
                                      className="input-group-text"
                                      style={{
                                        backgroundColor: "#9ca0ca",
                                        fontWeight: "500",
                                      }}
                                      onClick={searchValue}
                                    >
                                      ค้นหา
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <!-- Table  --> */}
                          <div className="overflow-auto">
                            {loadingTable ? (
                              <LoadingTable />
                            ) : data.length === 0 ? (
                              <CheckNoContent />
                            ) : (
                              <div style={{ height: "800px" }}>
                                <Table
                                  responsive
                                  className={
                                    isStacked
                                      ? "table-stacked"
                                      : "table_content table table-hover"
                                  }
                                >
                                  <thead>
                                    <tr style={{ zIndex: "1" }}>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          textAlign: "center",
                                          width: "10%",
                                          minWidth: "200px",
                                          backgroundColor: "#666699",
                                          height: "80px",
                                          color: "white",
                                        }}
                                      >
                                        <p>ชื่อ-นามสกุล</p>
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "10%",
                                          minWidth: "150px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>ตำแหน่ง</p>
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "5%",
                                          minWidth: "160px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>QR Code</p>
                                      </th>

                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "10%",
                                          minWidth: "160px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>สิทธิ์ผู้ใช้ทั่วไป</p>
                                      </th>
                                      {DataToken_.groups.includes(
                                        "RTAFPersonAdmin"
                                      ) === true ? (
                                        <th
                                          scope="col"
                                          style={{
                                            fontSize: "12px",
                                            width: "10%",
                                            minWidth: "160px",
                                            textAlign: "center",
                                            backgroundColor: "#8181B8",
                                            color: "white",
                                            zIndex: "1",
                                          }}
                                        >
                                          <p>สิทธิ์เจ้าหน้าที่กำลังพล ทอ.</p>
                                        </th>
                                      ) : (
                                        ""
                                      )}
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "10%",
                                          minWidth: "160px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>สิทธิ์เจ้าหน้าที่ทดสอบ</p>
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "10%",
                                          minWidth: "160px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>สิทธิ์เจ้าหน้าที่กำลังพลหน่วย</p>
                                      </th>

                                      {/* : ""} */}
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "12px",
                                          width: "5%",
                                          minWidth: "100px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          zIndex: "1",
                                        }}
                                      >
                                        <p>การจัดการ</p>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      backgroundColor:
                                        "rgb(247, 247, 247, 0.7)",
                                    }}
                                  >
                                    {data.map((Data, i) => (
                                      <tr className="raw" key={i}>
                                        <td
                                          className="text-center"
                                          data-label="ชื่อ - นามสกุล"
                                          style={{
                                            fontSize: "14px",
                                            backgroundColor: "#d0d9ff",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          {(pageNumber - 1) * 25 + i++ + 1}.{" "}
                                          {Data.full_name}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            fontSize: "14px",
                                            verticalAlign: "middle",
                                          }}
                                          data-label="ตำแหน่ง"
                                        >
                                          {Data.position}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{ fontSize: "14px" }}
                                          data-label="QR code"
                                        >
                                          <div style={{ fontSize: "14px" }}>
                                            <ModalQRCodeMember
                                              af_id={Data.af_id}
                                              person_id={Data.person_id}
                                              full_name={Data.full_name}
                                            />
                                          </div>
                                        </td>
                                        <YourInputComponent
                                          groups={Data.groups}
                                          id={Data.id}
                                        />
                                        <td
                                          className="text-center  "
                                          style={{
                                            fontSize: "14px",
                                            verticalAlign: "middle",
                                          }}
                                          data-label="การจัดการ"
                                        >
                                          <div className="row col-12 col-lg-12 col-sm-12 d-flex m-0 ">
                                            <div className="col-12 mt-2 ">
                                              <Link
                                                to={`/PageEditUserData`}
                                                state={{
                                                  idUser: Data.id,
                                                  search: search,
                                                  pageNumber: pageNumber,
                                                  AmountPage: AmountPage,
                                                }}
                                              >
                                                <button
                                                  type="button"
                                                  className="btn btn-primary "
                                                  style={{
                                                    fontSize: "14px",
                                                    width: "115px",
                                                    backgroundColor:
                                                      "rgb(2, 117, 216,0.80)",
                                                    border: "none",
                                                  }}
                                                >
                                                  ตรวจสอบข้อมูล
                                                </button>
                                              </Link>
                                            </div>
                                            <div className="col-12 mt-2  ">
                                              <button
                                                type="button"
                                                className="btn btn-secondary"
                                                style={{
                                                  fontSize: "14px",
                                                  width: "115px",
                                                  backgroundColor:
                                                    "RGB(255, 181, 69,0.90)",
                                                  border: "none",
                                                }}
                                                onClick={() => {
                                                  UpdateData_id(Data.person_id);
                                                }}
                                              >
                                                Update ข้อมูล
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <!-- End Table  --> */}
                        <ModalReFreshUpdate
                          show={isModalOpen}
                          onSave={handleSave}
                          onClose={() => setIsModalOpen(false)}
                          setChkEmpty={setChkEmpty}
                          User_id={User_id}
                          setUser_id={setUser_id}
                          setloadingData_id={() => setloadingData_id(true)}
                          loadingData_id={loadingData_id}
                        />

                        <ModalPagination
                          pageNumber={pageNumber}
                          AmountPage={AmountPage}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Form>
        </div>
      </Layout>
    </>
  );
};

export default PageManageUser;
